@for (action of breadcrumbs; track action.id; let isLast = $last) {
  <etn-action [action]="action"></etn-action>
  @if (!isLast) {
    <etn-icon [name]="breadcrumbSeparatorIcon"></etn-icon>
  }
}
